import { ValidationResult } from "./validator";

export const countErrorsInARow = (obj: Record<string, ValidationResult<unknown>>) => {
    return Object.values(obj).filter(value => {
        if (typeof value !== 'object') return false;
        return value.errors
    }).length;
}